const ButtonsActions = function () {
    return {
        title: "",
        counter: 0,
        edit: {
            active: false,
            disabled: true,
        },
        duplicate: {
            active: false,
            disabled: true,
        },
        add: {
            active: false,
            disabled: false,
        },
        addPlus: {
            active: false,
            disabled: true,
        },
        export: {
            active: false,
            disabled: true,
            onClick: (e) => {},
        },
        import: {
            active: false,
            disabled: true,
            onClick: (e) => {},
        },
        delete: {
            active: false,
            disabled: true,
        },
        editColumn: {
            active: false,
            disabled: true,
            status: null,
        },
        filter: {
            active: false,
            click: false,
            disabled: true,
            applied: false,
        },
        trash: {
            active: false,
            click: false,
            disabled: true,
        },
        topBack: {
            active: false,
            click: false,
            disabled: true,
        },
        settings: {
            active: false,
            click: false,
            disable: true,
        },
        markAllAsRead: {
            active: false,
            disabled: true,
            onClick: null,
        },
        searcher: (e) => {},
    };
};

export default ButtonsActions;
